import { render, staticRenderFns } from "./ChatQuickReplies.vue?vue&type=template&id=daae5ffa&scoped=true"
import script from "./ChatQuickReplies.vue?vue&type=script&lang=js"
export * from "./ChatQuickReplies.vue?vue&type=script&lang=js"
import style0 from "./ChatQuickReplies.vue?vue&type=style&index=0&id=daae5ffa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "daae5ffa",
  null
  
)

export default component.exports